import React from 'react'
import {injectIntl} from 'react-intl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Dialog from 'components/Dialog'
import Autocomplete from 'components/Autocomplete'

const ends = {
    to: 'to',
    duration: 'duration'
}

class EventDialog extends React.Component {
    constructor(props) {
        super(props)

        const end = props.data ? props.data.to ? ends.to : props.data.duration ? ends.duration : ends.to : ends.to

        this.state = {
            title: props.data ? props.data.title : '',
            from: props.data ? props.data.from : props.dates[0].id,
            end,
            to: props.data ? props.data.to ? props.data.to : end === ends.to ? 'none' : '' : 'none',
            duration: props.data ? props.data.duration : '',
            description: props.data ? props.data.description : ''
        }
    }

    handleChange = (e) => {
        if (e.target.name === 'end') {
            if (e.target.checked) {
                this.setState({
                    end: ends.duration,
                    duration: this.props.numbers[0].id,
                    to: ''
                })
            } else {
                this.setState({
                    end: ends.to,
                    to: this.props.dates[0].id,
                    duration: ''
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }
    }

    handleDelete = () => {
        this.props.handleEditorUpdate(this.props.id)
        this.props.handleClose()
    }

    handleEdit = () => {
        const obj = {
            title: this.state.title,
            from: this.state.from,
            to: this.state.to === 'none' ? '' : this.state.to,
            duration: this.state.duration === 'none' ? '' : this.state.duration,
            description: this.state.description,
        }

        if (this.props.data) {
            this.props.handleEditorUpdate(this.props.id, obj)
        } else {
            this.props.insertBlock(this.props.type, obj)
        }

        this.props.handleClose()
    }

    render() {
        const {intl, subs, dates, numbers} = this.props
        const invalid = !this.state.title

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose} fullWidth>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.event_settings"})}
                </DialogTitle>
                <DialogContent>
                    <Autocomplete
                        value={this.state.title}
                        label={intl.formatMessage({id: "editor.event_label"})}
                        onChange={(value) => this.setState({title: value})}
                        options={subs.map(item => item.name)}
                        component='input'
                        style={{marginBottom: '20px'}}
                    />
                    <FormControl style={{width: '100%', marginBottom: '20px'}} variant="standard">
                        <InputLabel>
                            {intl.formatMessage({id: "editor.event_from"})}
                        </InputLabel>
                        <Select
                            value={this.state.from}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'from'
                            }}
                        >
                            {dates.map(item =>
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    {dates.length && this.state.end === ends.to &&
                        <FormControl style={{width: '100%', marginBottom: '20px'}} variant="standard">
                            <InputLabel>
                                {intl.formatMessage({id: "editor.event_to"})}
                            </InputLabel>
                            <Select
                                value={this.state.to}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'to'
                                }}
                            >
                                <MenuItem value='none'>
                                    {intl.formatMessage({id: "editor.event_none"})}
                                </MenuItem>
                                {dates.map(item =>
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {this.state.end === ends.duration &&
                        <FormControl style={{width: '100%', marginBottom: '20px'}} variant="standard">
                            <InputLabel>
                                {intl.formatMessage({id: "editor.event_duration"})}
                            </InputLabel>
                            <Select
                                value={this.state.duration}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'duration'
                                }}
                            >
                                <MenuItem value='none'>
                                    {intl.formatMessage({id: "editor.event_none"})}
                                </MenuItem>
                                {numbers.map(item =>
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.name}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {numbers.length &&
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.end === ends.to ? false : true}
                                    name="end"
                                    onChange={this.handleChange}
                                />
                            }
                            label={intl.formatMessage({id: "editor.use_event_duration"})}
                            style={{marginBottom: '20px'}}
                        />
                    }
                    <Autocomplete
                        value={this.state.description}
                        label={intl.formatMessage({id: "editor.event_description"})}
                        onChange={(value) => this.setState({description: value})}
                        options={subs.map(item => item.name)}
                        component='textarea'
                        style={{height: '150px'}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleEdit}
                        disabled={invalid}
                        variant="contained"
                        color="primary"
                    >
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(EventDialog)
